import Vue from 'vue';
import store from './../../store';
import packageTransformer from './../../transformers/packageOrderProduct';

const success = ({ data }, resolve) => {
  const packages = packageTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllPackageOrderProducts', packages);
  resolve();
};

const failed = (error, reject) => reject(error);

export default orderId => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`packageOrderProduct/${orderId}`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/packageOrderProduct/all.js